import {
  LoginOTPRequest,
  putRequestOTPLogin,
  RequestOTPResponse,
} from '@back-office/http';
import { FlowReturn } from 'mobx-state-tree/dist/core/flow';
import { LOCKED_USER_ERROR_MESSAGE, ResponseMessage } from '../../constants';
import { Self } from '../common';

function* putOtpLoginRequest(
  self: Self,
  body: LoginOTPRequest
): Generator<Promise<FlowReturn<RequestOTPResponse>>> {
  self.isLoading = true;
  try {
    const response = yield putRequestOTPLogin(body);
    const { data, status } = (response as RequestOTPResponse).data;
    if (status.code === 1000) {
      self.otp.reset();
      self.otp = { ...self.otp, ...data };
      return Promise.resolve(ResponseMessage.OK);
    }
    if (status.code === 9500) {
      self.auth.reset();
      if (status.messages[0] === LOCKED_USER_ERROR_MESSAGE) {
        return Promise.resolve('login_form.user_locked');
      }
      return Promise.resolve('login_form.invalid_username_or_password');
    }
    self.alert.title = status.messages[0];
    self.alert.open = true;
    return Promise.reject(new Error(ResponseMessage.Error));
  } catch (e) {
    self.alert.title = 'login_form.internal_server_error';
    self.alert.open = true;
    return Promise.reject(new Error(e.message));
  } finally {
    self.isLoading = false;
  }
}

export default putOtpLoginRequest;
